import { APP_URL, isProd } from "../constants/system";
import { DefaultTheme, ThemeName } from "../constants/theme";
import { IFullTheme, ILegalDocuments } from "../types/theme";
import { getThemeName } from "./storage";

export const getProdTheme = (): IFullTheme => {
  const themeCustom = JSON.parse(import.meta.env.VITE_APP_THEME || "{}");
  return {
    ...DefaultTheme,
    ...themeCustom,
    colors: { ...DefaultTheme.colors, ...themeCustom.colors },
  };
};

export const getTheme = async () => {
  try {
    if (isProd && import.meta.env.VITE_APP_THEME) return;
    const themeEnabled = getThemeName() || "";

    if (themeEnabled?.toLowerCase() !== ThemeName.Ca.toLowerCase()) {
      const response = await fetch(
        `${APP_URL}/themes/${themeEnabled
          .toLowerCase()
          .replace(/ /g, "-")}/config.json`,
      );
      const theme = await response.json();
      return {
        ...DefaultTheme,
        ...theme,
        colors: { ...DefaultTheme.colors, ...theme.colors },
      };
    }
  } catch (e) {
    console.log("Invalid theme. Default will be used: ", e);
    return DefaultTheme;
  }
};

export const getImage3x = (name?: string) => {
  if (!name) return;
  const folderPath = `${APP_URL}/themes/${
    import.meta.env.VITE_CDN_FOLDER_NAME
  }/images`;
  return {
    oneX: `${folderPath}/1x/${name}`,
    twoX: `${folderPath}/2x/${name}`,
    threeX: `${folderPath}/3x/${name}`,
  };
};

export const getDocUrl = (
  language: string,
  legals?: ILegalDocuments,
  type?: "privacy" | "term" | "faq" | null,
) => {
  if (!legals || !type) return "";
  try {
    if (type === "privacy") {
      return legals[language]?.privacyPolicy || "";
    }
    if (type === "term") {
      return legals[language]?.termsAndConditions || "";
    }
    return legals[language]?.faq || "";
  } catch (e) {
    console.log(e);
    return "";
  }
};
